import {Chip} from '@mui/material';
import type {SyncStatus} from '../../types/iap';

interface Props {
    status: SyncStatus;
    error?: string;
}

export function StoreSyncStatusChip({status, error}: Props) {
    const config = ({
        SYNCED:  {color: 'success' as const, label: '동기화됨'},
        PENDING: {color: 'warning' as const, label: '대기'},
        FAILED:  {color: 'error'   as const, label: '실패'},
    } as const)[status] ?? {color: 'default' as const, label: status};

    return (
        <Chip
            size="small"
            color={config.color}
            label={config.label}
            title={error}
        />
    );
}
